import { DataError } from '../application'

export class HttpError<T> extends DataError<number> {
  readonly payload

  constructor(code: number, message: string, payload?: T, cause?: Error) {
    super(code, message, cause)

    this.payload = payload

    // Ensures the prototype chain is correct
    Object.setPrototypeOf(this, HttpError.prototype)
  }

  toString = () => `
    Code: ${this.code}\n
    Message: ${this.message || '-'}\n
    Payload: ${JSON.stringify(this.payload) || '-'}\n
    Cause: ${this.cause ? ('toString' in this.cause ? this.cause.toString() : this.cause) : '-'}
  `
}
